export default "<app-prezzi-tariffa\n  [service]=\"service\"\n></app-prezzi-tariffa>\n";